import React from 'react';
import { Button } from '@mui/material';
// ICONS
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
// HOOKS
import { useAppDispatch, useAppSelector } from '../../hooks';
// STORE
import { getThemeMode, toggleTheme } from '../../store/ConfigSlice';
// CONSTANTS
import { TP_COLORS } from '../../constants';

interface IProps {
  // eslint-disable-next-line react/require-default-props
  toggleDrawer?: () => void;
}

const ThemeSwitcher: React.FC<IProps> = ({ toggleDrawer }) => {
  // HOOKS
  const themeMode = useAppSelector(getThemeMode);
  const dispatch = useAppDispatch();

  // METHODS
  const onChangeTheme = () => {
    setTimeout(() => {
      dispatch(toggleTheme());
      if (toggleDrawer) {
        toggleDrawer();
      }
    }, 300);
  };

  // RENDER
  const startIcon = themeMode === 'light' && (
    <LightModeIcon color="secondary" />
  );
  const endIcon = themeMode === 'dark' && <DarkModeIcon color="secondary" />;

  return (
    <Button
      size="large"
      disableElevation
      fullWidth
      variant="contained"
      color="secondary"
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        backgroundColor:
          themeMode === 'dark'
            ? TP_COLORS.paperGray.dark
            : TP_COLORS.paperGray.light,
        maxWidth: '120px',
        borderRadius: '100px',
        height: '40px',
        color: 'text.primary',
        fontWeight: 600,
        justifyContent: 'space-between',
        '&:hover': {
          backgroundColor:
            themeMode === 'dark'
              ? TP_COLORS.paperGray.dark
              : TP_COLORS.paperGray.light,
        },
      }}
      onClick={onChangeTheme}
    >
      {themeMode === 'light' ? 'Light' : 'Dark'}
    </Button>
  );
};

export default ThemeSwitcher;
